import { Component } from '@angular/core';
import { EventEmitterService } from '../../services/event-emitter.service';

@Component({
  standalone: false,
  selector: 'app-menu-mobile',
  templateUrl: './menu-mobile.component.html',
  styleUrl: './menu-mobile.component.scss',
})
export class MenuMobileComponent {
  constructor(public eventEmitterService: EventEmitterService) {}
}
